import { createSlice } from '@reduxjs/toolkit'

const DEFAULT_REDIRECT_DESTINATION = '/app/personal/ai_notetaker'

const loadingModalSlice = createSlice({
  name: 'loadingModal',
  initialState: {
    showAcknowledgementLoadingModal: false,
    showRecordingRulesLoadingModal: false,
    acknowledgementRedirectDestination: DEFAULT_REDIRECT_DESTINATION,
  },
  reducers: {
    closeLoadingModal: (state) => {
      state.showAcknowledgementLoadingModal = false
      state.showRecordingRulesLoadingModal = false
      state.acknowledgementRedirectDestination = DEFAULT_REDIRECT_DESTINATION
    },
    setAcknowledgementRedirectDestination: (state, action) => {
      state.acknowledgementRedirectDestination = action.payload
    },
    showAcknowledgementLoadingModal: (state) => {
      state.showAcknowledgementLoadingModal = true
    },
    showRecordingRulesLoadingModal: (state) => {
      state.showRecordingRulesLoadingModal = true
    },
  },
})

export const {
  reducer,
  actions: {
    closeLoadingModal,
    setAcknowledgementRedirectDestination,
    showAcknowledgementLoadingModal,
    showRecordingRulesLoadingModal,
  },
} = loadingModalSlice
